import React from "react";
import AmenitiesV2 from "./amenitiesv2";
import ListingDetails from "./listingdetails";
import FooterV2 from "./footerv2";
import FloorplansV2 from "./floorplanv2";
import ExtraPhotos from "./extraphotos";

export default class Print extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orientation: "landscape",
      copySize: null,
      office: {
        name: "",
        license: "",
      },
    };
  }

  calcPrintLayout() {
    if (this.props.listing.isIdx) {
      //testing
      this.setState({ copySize: "full" });
    } else {
      this.props.listing.print.isLongCopyLayout
        ? this.setState({ copySize: "full" })
        : this.setState({ copySize: "min" });

      if(this.props.listing.print.mainImage) {
        this.props.listing.print.mainImage.orientation === "portrait"
          ? this.setState({ orientation: "portrait" })
          : this.setState({ orientation: "landscape" });
      }
    }

    if (this.props.listing.floorplans) {
      this.setState({
        floorplans: "page-break",
      });
    }
  }

  calcIdxLayout() {
    if (this.props.listing.isIdx) {
      let orientation,
        img = this.props.listing.images[0].src;

      if (typeof window !== "undefined") {
        img = document
          .getElementsByClassName("main-image")[0]
          .getElementsByTagName("img")[0];
      }

      if (img.naturalWidth > img.naturalHeight) {
        orientation = "landscape";
      } else if (img.naturalWidth < img.naturalHeight) {
        orientation = "portrait";
      } else {
        orientation = "landscape";
      }

      this.setState({ orientation: orientation });
    }
  }

  componentWillMount() {
    this.calcPrintLayout();
  }

  componentDidMount() {
    var listing = this.props.listing;
    if (listing) {
      if (listing.isIdx && !listing.idxOfficeUrl) {
        return;
      }
    }

    if (this.props.listing.isIdx) {
      this.calcIdxLayout();
    }
  }

  render() {
    let listing, layoutClasses, imageLimit, printImages;
    listing = this.props.listing;

    layoutClasses = `${this.state.orientation} ${this.state.copySize} ${this.state.floorplans}`;

    if (
      this.state.orientation === "portrait" &&
      this.state.copySize === "full"
    ) {
      imageLimit = 5;
    }

    if (
      this.state.orientation === "portrait" &&
      this.state.copySize === "min"
    ) {
      imageLimit = 3;
    }

    if (
      this.state.orientation === "landscape" &&
      this.state.copySize === "full"
    ) {
      imageLimit = 3;
    }

    if (
      this.state.orientation === "landscape" &&
      this.state.copySize === "min"
    ) {
      imageLimit = 4;
    }

    printImages = listing.images
      .filter((images) => images.orientation !== "portrait")
      .slice(1, imageLimit)
      .map((image, index) => {
        return (
          <div className={`sub-image${index + 1}`} key={index}>
            <img alt={`listing view ${index + 1}`} src={image.src} />
          </div>
        );
      });

    return (
      <div>
        <div id="print-container" className={layoutClasses}>
          <div className="print-image-container">
            <div className="main-image">
              <img alt={listing.title} src={(listing.images.length !== 0) ? listing.images[0].src : ''} />
            </div>

            {printImages}
          </div>

          <div className="amenities-container">
            <AmenitiesV2 listing={listing} />
          </div>
          <div className="listing-details-container">
            <ListingDetails listing={listing} />
          </div>
          <div className="footer-container">
            <FooterV2 listing={listing} office={this.state.office} />
          </div>
        </div>

        {listing.images.length >= 14 ? (
          <ExtraPhotos
            listing={listing}
            imageLimit={imageLimit}
            office={this.state.office}
          />
        ) : null}
        {listing.floorplans ? (
          <FloorplansV2 listing={listing} office={this.state.office} />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/listing-detail/print/print.js